import { combineReducers } from '@reduxjs/toolkit';

import { clearFilter, filterSlice, setFilter } from './filter';

export type { FilterForm, TimeFilterOptionsType } from './filter';

export const ADVANCED_FILTER_REDUCER_PATH = 'advancedFilters';

export const advancedFiltersReducer = combineReducers({
  filter: filterSlice.reducer,
});

export const filterActions = {
  clearFilter,
  setFilter,
};

export interface RootState {
  advancedFilters: ReturnType<typeof advancedFiltersReducer>;
}
